import { Trash2, ArrowUp } from "lucide-react";

const BARS = Array.from({ length: 28 });

export function VoiceRecordingBar({ secs, onCancel, onSend, cancelTestId = "voice-cancel", sendTestId = "voice-send" }) {
  const fmt = `${Math.floor(secs / 60)}:${String(secs % 60).padStart(2, "0")}`;
  return (
    <div className="flex w-full items-center gap-2.5 px-1 py-1">
      <button
        type="button"
        data-testid={cancelTestId}
        onClick={onCancel}
        aria-label="Cancel recording"
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
      >
        <Trash2 className="h-5 w-5" strokeWidth={1.8} />
      </button>
      <span className="relative flex h-2.5 w-2.5 shrink-0">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-red-500" />
      </span>
      <span data-testid="rec-timer" className="shrink-0 text-sm font-semibold tabular-nums text-red-500">
        {fmt}
      </span>
      <div className="flex h-6 flex-1 items-center gap-[3px] overflow-hidden">
        {BARS.map((_, i) => (
          <span
            key={i}
            className="maxx-wave-bar w-[3px] shrink-0 rounded-full bg-red-500/60"
            style={{ height: "100%", animationDelay: `${(i % 14) * 70}ms` }}
          />
        ))}
      </div>
      <button
        type="button"
        data-testid={sendTestId}
        onClick={onSend}
        aria-label="Send recording"
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground"
      >
        <ArrowUp className="h-5 w-5" />
      </button>
    </div>
  );
}
